import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

const BASE = "/api/v1/erp/open-containers";

export const fetchOpenContainers = createAsyncThunk("openContainer/fetchAll", async (params?: string): Promise<any> => {
  const query = params ? `?${params}` : "";
  const response = await axios.get(`${BASE}${query}`);
  return response.data;
});

export const fetchExpiringContainers = createAsyncThunk("openContainer/fetchExpiring", async (params?: string): Promise<any> => {
  const query = params ? `?${params}` : "";
  const response = await axios.get(`${BASE}/expiring${query}`);
  return response.data;
});

export const openContainer = createAsyncThunk("openContainer/open", async (payload: any): Promise<any> => {
  const response = await axios.post(BASE, payload);
  return response.data;
});

export const finishContainer = createAsyncThunk("openContainer/finish", async (id: string): Promise<any> => {
  const response = await axios.post(`${BASE}/${id}/finish`);
  return response.data;
});
